import { TFunction } from 'react-i18next';
import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';
import { PARTNER_FORM_FIELDS, PARTNER_FORM_FIELDS_NAMES } from './new-partner-form';
import { IPartnerList } from '../../store/merchnts/merchant-interfaces';

interface INewPartnerInformationInputs {
	t: TFunction;
	partner: IPartnerList;
	emailAdditionalClasses: () => string;
}

export const NEW_PARTNER_INFORMATION_INPUTS = (props: INewPartnerInformationInputs): IFormInputProps[] => {
	const { t, partner, emailAdditionalClasses } = props;
	return [
		{
			key: PARTNER_FORM_FIELDS.FIRST_NAME,
			fieldName: PARTNER_FORM_FIELDS.FIRST_NAME,
			placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(PARTNER_FORM_FIELDS_NAMES.FIRST_NAME)}`,
			label: t(PARTNER_FORM_FIELDS_NAMES.FIRST_NAME),
			inputType: InputType.Text,
			required: true,
			additionalClasses: partner?.id ? 'col-sm-6 col-md-3' : 'col-sm-6 col-md-6',
			autoComplete: 'off'
		},
		{
			key: PARTNER_FORM_FIELDS.LAST_NAME,
			fieldName: PARTNER_FORM_FIELDS.LAST_NAME,
			placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(PARTNER_FORM_FIELDS_NAMES.LAST_NAME)}`,
			label: t(PARTNER_FORM_FIELDS_NAMES.LAST_NAME),
			inputType: InputType.Text,
			required: true,
			additionalClasses: partner?.id ? 'col-sm-6 col-md-3' : 'col-sm-6 col-md-6',
			autoComplete: 'off'
		},
		{
			key: PARTNER_FORM_FIELDS.EMAIL,
			fieldName: PARTNER_FORM_FIELDS.EMAIL,
			placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(PARTNER_FORM_FIELDS_NAMES.EMAIL)}`,
			label: t(PARTNER_FORM_FIELDS_NAMES.EMAIL),
			inputType: InputType.Text,
			required: true,
			additionalClasses: emailAdditionalClasses(),
			readOnly: partner?.id && partner?.mainContact?.userCreated && true,
			disabled: partner?.id && partner?.mainContact?.userCreated && true,
			autoComplete: 'off'
		},
		{
			key: PARTNER_FORM_FIELDS.PHONE,
			fieldName: PARTNER_FORM_FIELDS.PHONE,
			placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(PARTNER_FORM_FIELDS_NAMES.PHONE)}`,
			label: t(PARTNER_FORM_FIELDS_NAMES.PHONE),
			inputType: InputType.Phone,
			defaultCountry: 'US',
			required: true,
			additionalClasses: partner?.id ? 'col-sm-6 col-md-3' : 'col-sm-6 col-md-6',
			autoComplete: 'off'
		},
	];
};
